import { render, staticRenderFns } from "./AcademyHeaderHomepage.vue?vue&type=template&id=6cc01597&"
import script from "./AcademyHeaderHomepage.vue?vue&type=script&lang=js&"
export * from "./AcademyHeaderHomepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports